export enum AddOnsTypes {
  GUARANTEED_COE = 'Guaranteed COE',
}
